import React from 'react'
import {booking} from '@whyhotel/common-schema'

export interface NoShowPolicyProps {
  offer: booking.BookingOffer
}

const NoShowPolicy = ({offer}: NoShowPolicyProps) => {
  return (
    <div>
      <h3 className="font-semibold text-base border-b mb-2">No Show Policy</h3>
      <p
        className="text-sm"
        dangerouslySetInnerHTML={{__html: offer?.noShowFee?.description}}
      />
    </div>
  )
}

export default NoShowPolicy
